import { set_ai_opts_for_preview } from '../../formElements/RSAI/utils';
import { onLink, save } from '../../handlers';
import { updateSectionData } from '../../handlers/utils';
import { getUsefulVars } from '../../handlers/helpers';
import { updateBulletData } from '../../formElements/Bullets/utils';

export const hasSection = (props, sectionName) => {
  const stateProps = props.stateProps;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const resumes = stateProps.dataToSave.saved.resumes;
  const resume = resumes[resumeIndex];
  if ((resume[sectionName] !== undefined && resume[sectionName].length > 0) || (sectionName === 'emptySections' || sectionName === 'start')) {
    return true;
  }
  return false;
};
export const openPreview = (props, index = -1) => {
  if (index !== -1) {
    props.stateProps.sectionData.resumeIndex = index;
  }
  const resumeIndex = props.stateProps.sectionData.resumeIndex;
  if (props.stateProps.dataToSave.saved.resumes[resumeIndex].download === undefined) {
    set_ai_opts_for_preview(props, resumeIndex);
  } else {
    onLink(false, props.formikProps, props.stateProps, 'preview', index, 'section', resumeIndex);
  }
};
export const canShowAccordion = (sectionObj, sectionName, myData) => {
  switch (sectionName) {
    case 'download':
    case 'emptySections':
      return true;

  }
  if (sectionObj && myData[sectionName] !== undefined) {
    if(myData[sectionName].length > 1) {
      return true;
    } else {
      if(myData[sectionName].length === 1) {
        if(Object.keys(myData[sectionName]).length > 0) {
          return true
        }
      }
    }
  }
    return false;

};
export const previewEditButton = (props, target, editableIndex) => {
  if (target === 'download') {
    const uv = getUsefulVars(props);
    uv.resume.regenCS = false;
    onLink(false, props.formikProps, props.stateProps, target, 0, 'section');

    props.stateProps.setaiopts([]);
  } else {
    onLink(false, props.formikProps, props.stateProps, target, editableIndex, 'section');
  }
};
export const getAccordionVars = (previews, sectionName, myData) => {
  let sectionObj = previews[sectionName];
  sectionObj = sectionName === 'download' && typeof sectionObj === 'undefined' ? {} : sectionObj;
  let label = '';
  let buttonLabel = 'Edit';
  if (typeof sectionObj !== 'undefined') {
    label = sectionObj.label === 'Download' ? 'Career Summary' : sectionObj.label;
  }
  if (sectionName === 'download') {
    if (myData.download !== undefined && myData.download[0] !== undefined && myData.download[0]['D1'] !== undefined) {
      buttonLabel = 'Regenerate';
    } else {
      buttonLabel = 'Generate';
    }
  }
  return [sectionObj, label, buttonLabel];
};
export const getQuestions = (previews, sectionName) => {
  const sectionObj = previews[sectionName];
  if (typeof sectionObj !== 'undefined' && typeof sectionObj.questions !== 'undefined') {
    return sectionObj.questions[0];
  } else {
    return [];
  }
};
export const getEmptySections = (props) => {
  const allSections = [
    ['academic-projects', 'Academic Projects'],
    ['awards-recognitions', 'Awards & Recognitions'],
    ['contact', 'Contact'],
    ['education', 'Education'],
    ['extracurricular-activities', 'Extracurricular Activities'],
    ['languages', 'Languages'],
    ['licenses-certifications', 'Licenses & Certifications'],
    ['professional-experience', 'Professional Experience'],
    ['technical-skills', 'Expertise & Skills'],
    ['computer-skills', 'Computer Skills'],
    ['volunteer-experience', 'Volunteer Experience'],
  ];
  const emptySections = [];
  allSections.forEach(([sectionName, sectionTitle]) => {
    if (!hasSection(props, sectionName)) {
      emptySections.push([sectionName, sectionTitle]);
    }
  });
  return emptySections;
};
export const freeFormEditCareerSummary = (e, uv) => {
  uv.resume.download[0]['D1'] = e.currentTarget.value;
  save(uv.stateProps, uv.resumeIndex);
};
export const freeFormEdit = (e, option, sectionIndex, uv, item) => {
  const newLabel = e.currentTarget.value;
  const resumes = uv.stateProps.dataToSave.saved.resumes;
  option.label = newLabel;
  const bullets = resumes[uv.resumeIndex]['professional-experience'][sectionIndex]['bulletsb'];
  for (const bullet of bullets) {
    if (bullet.key === option.key) {
      bullet.label = newLabel;
    }
  }
  for (const itemBullet of item['bulletsb']) {
    if (itemBullet.key === option.key) {
      itemBullet.label = newLabel;
    }
  }
  updateBulletData({
    selectedBullets: bullets,
  }, uv.stateProps);

};
export const returnToPreviewFromRegenerate = (props) => {
  updateSectionData({ sectionName: 'preview' }, props.stateProps);
};
export const composeBullet = (bullet) => {
  const labelParts = bullet.label.split('~');
  if (labelParts.length > 1) {

  }
  return labelParts.length > 1 ? labelParts[0] + bullet.buttonLabels[0] + labelParts[1] : labelParts[0];
};

export const getDivider = (startElem, endElem, divider = '-') => {
  if ((typeof startElem !== 'undefined' && startElem !== '') && (typeof endElem !== 'undefined' && endElem !== '')) {
    return divider;
  }
  return '';
};

export const getStartDate = (item) => {
  const month = item.start_month === undefined ? '' : item.start_month;
  const year = item.start_year === undefined ? '' : item.start_year;
  return month + ' ' + year;
};
export const getEndDate = (item) => {
  const month = item.end_month === undefined ? '' : item.end_month;
  const year = item.end_year === undefined ? '' : item.end_year;
  if (month === '' && year === '' || item.is_complete === 'yes' ) {
        return '- Present';
  }
  return '- ' + month + ' ' + year;
};